import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter, Route, Routes } from 'react-router'

import i18n from '@/lib/i18n'
import JoinPage from '@/pages/JoinPage'
import LegalPage from '@/pages/LegalPage'
import PreviewPage from '@/pages/PreviewPage'
import SessionPage from '@/pages/SessionPage'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Der Zustand kommt per Broadcast, nicht per Polling.
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
})

export default function App() {
    return (
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<JoinPage />} />
                        {/* Deeplink aus dem QR-Code am Beamer. */}
                        <Route path="/:code" element={<JoinPage />} />
                        <Route path="/runde" element={<SessionPage />} />
                        {/* Rechtsseiten - ohne Beitritt erreichbar. */}
                        <Route path="/datenschutz" element={<LegalPage page="privacy" />} />
                        <Route path="/impressum" element={<LegalPage page="imprint" />} />
                        {/* Screen-Vorschau - nur im Entwicklungsmodus. */}
                        {import.meta.env.DEV && (
                            <Route path="/vorschau" element={<PreviewPage />} />
                        )}
                    </Routes>
                </BrowserRouter>
            </QueryClientProvider>
        </I18nextProvider>
    )
}
